import { TrackingType } from '@shared/TimeTracker/types';

export enum RetroactiveTrackingActivityType {
  PHONE_CALL = 'PHONE_CALL',
  THERAPY_MEETING = 'THERAPY_MEETING',
  OTHER = 'OTHER',
}

export type RetroactiveTimeTracking = {
  id: string;
  userId: string;
  mentorId: string;
  trackingType: TrackingType;
  activityType: RetroactiveTrackingActivityType;
  activityName?: string | null;
  startTime: string;
  duration: number;
  endTime?: string;
  comments?: string;
  createdAt?: string;
  updatedAt?: string;
  retroactiveStartTime: Date | string | null;
  retroactiveDuration: number | null;
  retroactiveEndTime: string | null;
};

export type CreateTimeTrackingManuallyInput = Omit<
  RetroactiveTimeTracking,
  'id' | 'startTime' | 'duration' | 'endTime'
>;
export type UpdateTimeTrackingManuallyInput = Partial<RetroactiveTimeTracking>;
